<div class="list-container">
    <dynamic-table [props]="props" class="dynamic-table d-flex flex-column">
        <ng-container *ngFor="let asset of assets">
            <div *ngIf="asset" 
                class="asset-table-row info-cell ccc ccc-hover" 
                (click)="navigateToDetailHandler(asset.assetId)" 
                role="button"
                >
                <div class="info-container d-flex p-3">
                    <div class="col-lg-3 d-flex align-items-center">
                        <div HJSuppress>
                            <div class="manufacturer text-primary">{{asset.assetName}}</div>
                        </div>
                    </div>
                    <div class="col-lg-9 d-flex flex-column gap-4 ps-4">
                        <div class="details-grid-container">
                            <div class="column-content">
                                <div class="cell-title">{{'assetDriver.plateNumber' | translate}}</div>
                                <div HJSuppress class="cell-value">{{asset.registrationNumber || '-'}}</div>
                            </div>
                            <div class="column-content" >
                                <div class="cell-title">{{'assetDriver.serialNumber' | translate}}</div>
                                <div HJSuppress class="cell-value">{{asset.vin || '-'}}</div>
                            </div>
                            <div class="column-content">
                                <div class="cell-title">{{'assetDriver.availableServices' | translate}}</div>
                                <div HJSuppress class="d-flex align-items-center cell-value">
                                    {{asset.contractItemServices.length}}
                                    <i class="app-icon icon icon-info-circle info-tooltip-trigger ms-1"
                                        [ngbTooltip]="valueTooltip"
                                        tooltipClass="custom-tooltip opacity-100"
                                    ></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-3">
                    <div class="d-flex justify-content-end gap-3">
                        <button 
                            class="btn outline-btn red-btn" 
                            (click)="redirectReportIncident($event, asset.contractExternalEntityId, asset.assetId)">
                            {{'assetDriver.reportIncident' | translate}} 
                        </button>
                        <button 
                            class="btn outline-btn"    
                            (click)="redirectAssetJourney($event, asset.assetId)">
                            {{'assetDriver.seeAssetJourney' | translate}} 
                        </button>
                        <button 
                            class="btn btn-primary text-light" 
                            (click)="redirectDocumentRequest($event, asset.contractExternalEntityId, asset.assetId)">
                            {{'contractDetail.assets.documentRequest' | translate}} 
                        </button>
                    </div>
                </div>
            </div>

            <ng-template #valueTooltip>
                <ng-container
                  *ngFor="let contractItemService of asset?.contractItemServices"
                >
                  <div class="tooltip-row">
                    <span class="tooltip-label">
                      {{ contractItemService?.name }}
                    </span>
                  </div>
                  <div class="tooltip-separator"></div>
                </ng-container>
              </ng-template>
        </ng-container>
    </dynamic-table>
</div>

